// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"124":"alarmConfig","277":"deviceInfo","424":"EmailVerification","787":"signup","884":"admin","966":"login"}[chunkId] + "." + {"124":"e909d966","277":"d3e29912","424":"faf03027","787":"7a5b5433","884":"1349a1b1","966":"0bf55301"}[chunkId] + ".css";
};